import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Routes, Route, useNavigate, Navigate } from "react-router-dom"
import { authProtectedRoutes, publicRoutes, dealerRoutes } from "./routes"
import Authmiddleware from "./routes/route"
import { uId } from "common/utility";
import { useLocation } from 'react-router-dom';

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import Forbidden403 from "forbiddon"


const App = () => {
  const navigate = useNavigate()
  const publicArray = ["/logout", "/login", "/forgot-password", "/verify-login/:uuid", "/reset-password", "/register"]
  const [protectedRoutes, setProtectedRoutes] = useState([])

  useEffect(() => {
    const currentPath = location.pathname;
    const user = JSON.parse(localStorage.getItem("user"))
    const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"))
    if (user) {
      setProtectedRoutes(authProtectedRoutes(user.roleName))
    } else if (!isLoggedIn && !publicArray.includes(currentPath)) {
      navigate("/login")
    } else {
      setProtectedRoutes([])
    }
    const handleUnauthorizedEvent = () => {
      navigate("/login")
    }
    const handleForbiddenEvent = () => {
      navigate("/forbidden-zone")
    }

    window.addEventListener("unauthorized", handleUnauthorizedEvent)
    window.addEventListener("forbidden", handleForbiddenEvent)  

    return () => {
      window.removeEventListener("unauthorized", handleUnauthorizedEvent)
      window.removeEventListener("forbidden", handleForbiddenEvent)
    }

  }, [navigate])

  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={`p-${uId()}-${route.path}`}
            exact={true}
          />
        ))}

        {protectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware route={route}>
                <VerticalLayout>{route.component}</VerticalLayout>
              </Authmiddleware>
            }
            key={`c-${uId()}-${route.path}`}
            exact={true}
          />
        ))}

        {dealerRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware route={route}>
                <HorizontalLayout>{route.component}</HorizontalLayout>
              </Authmiddleware>
            }
            key={`a-${uId()}-${route.path}`}
            exact={true}
          />
        ))}
        <Route path="/forbidden-zone" element={<Forbidden403 />} />
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
